// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#drugInfoPreview .modal-dialog {\n  max-width: 1150px;\n}", ""]);
// Exports
module.exports = exports;
